export type SubscriptionTier = "Starter" | "Professional" | "Teams" | "Public Sector and Enterprises";

interface FeatureAccess {
  [featureName: string]: SubscriptionTier[];
}

export const 
featureAccessMap: FeatureAccess = {
  canCreateProject: ["Professional", "Public Sector and Enterprises"],
  canAccessRefinedRequirements: ["Professional", "Public Sector and Enterprises"],
  canInviteStakeholders: ["Professional", "Public Sector and Enterprises"],
  canUseBatchProcessing: ["Public Sector and Enterprises"],
  canIdentifyExistingSupplier: ["Professional","Public Sector and Enterprises"],
  canSetEvaluationCriteria: ["Public Sector and Enterprises"],
  canSetCriticalRequirements: ["Professional", "Teams", "Public Sector and Enterprises"],
  canAssignWeights: ["Professional", "Public Sector and Enterprises"],
  canDefineBudget: ["Professional", "Public Sector and Enterprises"],
  canUploadResponses: ["Professional", "Public Sector and Enterprises"],
  canAccessAdvanceOverviewFeatures: ["Professional", "Public Sector and Enterprises"],
  canGenerateRfp: ["Starter","Professional", "Teams", "Public Sector and Enterprises"],
  canUploadRfpResponsses: ["Starter","Professional", "Teams", "Public Sector and Enterprises"],
  canUploadRfp: ["Starter","Professional", "Teams", "Public Sector and Enterprises"],
  canDefineProject : ["Starter","Professional", "Teams", "Public Sector and Enterprises"],
  canAssignScore: ["Public Sector and Enterprises"],
  canAccessAnalysisAdvanceFeatures: ["Teams","Public Sector and Enterprises"],
};
